import React, { useRef, useState, useEffect, useCallback } from 'react';
import FormantEffect from './fm/FormantEffect.js';
import {connect} from 'react-redux';
import OperatorsMixer from './fm/OperatorsMixer.js';
import FilterSection from './FilterSection.js';
import FMParameter from './FMParameter.js';
import OscInfo from './OscInfo.js';
import OscillatorsContinuedComponent from './OscillatorsContinuedComponent.js';
import RackComponent from "components/effects/rack/RackComponent.js";
import Colors from 'components/Colors.js';
import FMOperatorControl from './FMOperatorControl.js';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import FMGenetix from './FMGenetix.js';
import LFOComponent from 'components/lfo/LFOComponent.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import OscillatorsComponent from './OscillatorsComponent.js';
import Notes from 'midi/Notes.js';
import Dropdown from 'react-dropdown'
import EnvelopesComponent from './EnvelopesComponent.js';
import SynthMods from './SynthMods.js';
import {useScroll} from 'components/effects/useScroll.js';
import '../../Instruments.scss';
import '../../Fm.scss';
import {AMP, OP_B1, OP_B2, OP_A, FILTER, PITCH, MODULATION} from 'constants/envelope-types.js';
import {ENVELOPE_OPTIONS} from './constants.js';

const colors = new Colors();

const RackSynthComponent = (props) => { 
    const instrumentRef = useRef(undefined);
    /*
    const {hideInfo} = useScroll({
        effectRef: instrumentRef,
        scrollContainer: props.scrollContainer[1],
        linkedParameterSelected: props.selectedParameter
    });
    */
    const hideInfo = false;

    const [showWaveform, setShowWaveform] = useState(undefined);
    const [oscillatorDetails, setOscillatorDetails] = useState(undefined);
    const [selectedOscillator, setSelectedOscillator] = useState(0);
    const [showMods, setShowMods] = useState(false);
    let instrument = props.instrument;
    let color = colors.getColorForTrack(props.track);
    if (colors.getBrightness(color) > 180) {
        color = colors.brighten(color, 0.6);
    }
    
    let osc = instrument.oscillatorNodes[selectedOscillator];

    useEffect(() => {
        let index = instrument.oscillatorNodes.indexOf(oscillatorDetails);
        setSelectedOscillator(index === -1 ? 0 : index);
    }, [setSelectedOscillator, oscillatorDetails]);

    useEffect(() => {
        if (!props.selectedParameter) {
            return;
        }
        let context = props.selectedParameter.context;
        if (context.instrument === instrument) {
            // parameter is indeed of this instrument
            let subDevice = context.subDevice;
            if (subDevice) {
                if (subDevice.oscillator) {
                    subDevice = subDevice.oscillator;
                }
                let index = instrument.oscillatorNodes.indexOf(subDevice);
                if (index > -1) {
                    setSelectedOscillator(index);
                    setOscillatorDetails(subDevice);
                }
            } else {
                // no sub-device, so set oscillator details to undefined
                // because its not in there...
                setOscillatorDetails(undefined);
            }
        }
    }, [props.selectedParameter,
        instrument,
        setSelectedOscillator,
        setOscillatorDetails]);

    const onClickMods = useCallback(() => {
        setShowMods(!showMods);
    }, [setShowMods, showMods]);
    
    let className = "instrument multi-synth rack-synth";
    if (props.planeMapping) {
        className += " plane-mapping";
    }

    const onClickInstrument = useCallback((e) => {
        e.stopPropagation();
        if (props.planeMapping) {
            props.planeMapping.randomlyMapParameters(props.instrument);
        }
    }, [props.planeMapping, props.instrument]);

    let inner = '';
    if (!hideInfo) {
        inner = (
            <div>
              <ConditionedComponent condition={!showMods}>
                <div className="inner">
                  <div className="instrument-section">
                    <RackComponent
                      color={color}
                      track={props.track}
                      scrollContainer={props.scrollContainer}
                      setSelectedOscillator={(osc) => {
                          setSelectedOscillator(
                              Math.max(0, instrument.oscillatorNodes.indexOf(osc)));
                      }
                                            }
                      send={props.send}
                      sequencerEngine={props.sequencerEngine}
                      effect={props.instrument}/>
                    <div
                      className="fm-parameters">
                      <div className="osc-name">{osc.name}</div>
                      <div className="fm-parameters-container">
                        <EffectParameterSlider
                          automation={props.automation}
                          name={'Harmonicity'}
                          sequencerEngine={props.sequencerEngine}
                          lfoEnabled={true}
                          parameter={osc.harmonicityParameter}
                          onParameterChanged={() => []}
                          isParameter={true}
                          min={0}
                          max={20}
                          step={0.01}
                        />
                        <EffectParameterSlider
                          automation={props.automation}
                          name={'Modulation'}
                          sequencerEngine={props.sequencerEngine}
                          parameter={osc.modulationIndexParameter}
                          lfoEnabled={true}
                          onParameterChanged={() => []}
                          isParameter={true}
                          min={0}
                          max={1000}
                          step={0.01}
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="sections">
                      <div className="instrument-section">
                        <OperatorsMixer
                          color={color}
                          setOscillatorDetails={setOscillatorDetails}
                          oscillatorDetails={oscillatorDetails}
                          sequencerEngine={props.sequencerEngine}
                          instrument={instrument}/>
                        {!showWaveform && !oscillatorDetails ? 
                         <FilterSection
                           automation={props.automation}
                           sequencerEngine={props.sequencerEngine}
                           instrument={instrument}
                         /> : ''}
                      </div>
                      {props.formant ?
                       <FormantEffect
                         track={props.track}
                         sequencerEngine={props.sequencerEngine}
                         formant={props.formant} instrument={instrument}/> : 
                       <div className="instrument-section envelopes">
                         <div className="instrument-subsection envelopes">
                           <EnvelopesComponent
                             color={color}
                             automation={props.automation}
                             envelopeOptions={ENVELOPE_OPTIONS}
                             sequencerEngine={props.sequencerEngine}
                             instrument={instrument}/>
                         </div>
                         <div className="aux-parameters">
                           <OscillatorsContinuedComponent
                             instrument={instrument}
                             selectedOscillator={selectedOscillator}
                             sequencerEngine={props.sequencerEngine}
                           />
                           <div
                             onClick={onClickMods}
                             className="mods-button common-button small-button">
                             {showMods ? 'BACK' : 'MODS'}
                           </div>
                         </div>
                       </div>
                      }
                    </div>
                  </div>
                </div>
              </ConditionedComponent>
              <ConditionedComponent condition={showMods}>
                <div className="clear-fix"/>
                <SynthMods instrument={instrument}/>
                <div
                  onClick={onClickMods}
                  className="mods-button common-button small-button">
                  {showMods ? 'BACK' : 'MODS'}
                </div>
              </ConditionedComponent>
            </div>
        );
    }

    return (
        <div
          ref={instrumentRef}
          onClick={onClickInstrument}
          className={className}>
          {hideInfo ? <div style={hideInfo}/> : inner}
          </div>);
}

const mapStateToProps = (state, props) => {
    return {
        selectedParameter: state.effects.accumulatorParameterSelected,
        planeMapping: state.effects.planeMapping,
        presetName: props.track.presetName,
        formant: state.instruments.showFormantEffect
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RackSynthComponent);
